module.exports = __webpack_public_path__ + "img/login_title.2c042276.png";